import Splash from '../components/Splash/Splash';
import LinearProgress from '../components/LinearProgress/LinearProgress';
import { useClientDataIfNeeded } from '../hooks/useClientData';

const defaultOptions = {
  forceFetch: false,
};

const withClientData =
  (BaseComponent, { forceFetch } = defaultOptions) =>
  ({ ...props }) => {
    const { data, loadingStatus } = useClientDataIfNeeded(forceFetch);

    if (loadingStatus === 'fetched') {
      return <BaseComponent {...props} clientData={data} />;
    }

    return (
      <>
        <Splash variant="light" />
        <LinearProgress />
      </>
    );
  };

export default withClientData;
